import * as R from "ramda";

export const SourceDisplay = {
    unknown: "Unknown",
    original: "Original value",
    manual: "Manual",
    empty: "-",
};

const isEmpty = value => R.isEmpty(value) || !value;

export const getSourceByPath = (
    originalEntity,
    modifiedEntity,
    events,
    path
) => {
    const updateEvents = events
        .filter(
            event =>
                event.action === "EntityUpdated" &&
                event.detail.entityMerged.key.ulid === modifiedEntity.key.ulid
        )
        .reverse();

    const currentValue = R.path(path, modifiedEntity);

    if (isEmpty(currentValue)) {
        return SourceDisplay.empty;
    }

    const equalsCurrentValue = entity =>
        R.equals(currentValue, R.path(path, entity));

    for (const event of updateEvents) {
        const {
            source,
            entityBefore,
            entityAfter,
            entityMerged,
        } = event.detail;
        if (
            equalsCurrentValue(entityMerged) &&
            !equalsCurrentValue(entityBefore)
        ) {
            if (equalsCurrentValue(entityAfter)) {
                return source;
            } else {
                return SourceDisplay.manual;
            }
        }
    }
    return equalsCurrentValue(originalEntity)
        ? SourceDisplay.original
        : SourceDisplay.unknown;
};
